import React, { useState, useEffect } from 'react'
import { Panel, List, FlexboxGrid, Icon, Avatar } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { isEmpty } from 'lodash-es'
import pathname from '../../constants/pathname'
import './styles.less'
import { getStatusOngoingProject } from '../../redux/actions/dashboard'
import DashboradToggle from '../dashboard/DashboradToggle'

export default function OngoingProjectList({ config, onSettingChange = () => {} }) {
  const history = useHistory()
  const [schema, setSchema] = useState()
  // const [isLoading, setIsLoading] = useState(false)

  const fontStyle = {
    margin: '0px 10px 0px 10px',
    color: '#f44336',
    fontSize: 12,
  }

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard()
    }
  }, [])

  const handelGetSchemaDashboard = async () => {
    // setIsLoading(true)
    try {
      const response = await getStatusOngoingProject(0, 0)
      // console.log('getStatusOngoingProject => ', response)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    // setIsLoading(false)
  }

  return (
    <>
      {config && (
        <DashboradToggle
          onChange={onSettingChange}
          dashboradName={config.key}
          checked={config.show}
          style={{ marginTop: 20, marginBottom: -15 }}
        />
      )}

      <Panel
        header={schema?.header}
        shaded
        collapsible
        bordered
        defaultExpanded
        bodyFill
        className="project-list"
        style={{ marginTop: 20 }}
      >
        <List style={{ height: config ? '100px' : '430px' }}>
          {!isEmpty(schema?.data) &&
            schema.data.map((item, index) => (
              <List.Item key={index} index={index}>
                <FlexboxGrid>
                  <FlexboxGrid.Item colspan={4} className="circle-icon">
                    <Avatar
                      circle
                      size="md"
                      style={{
                        backgroundColor: 'transparent',
                        color: 'white',
                        borderStyle: 'solid',
                        borderWidth: 2,
                        borderColor: 'darkgray',
                      }}
                      onClick={() => {
                        if (!config) {
                          sessionStorage.setItem('projectId', item.projectVersionId)
                          sessionStorage.setItem('param', '')
                          history.push({
                            pathname: `${pathname.proposal.overview.overviewCoworker}`,
                          })
                        }
                      }}
                    >
                      <Icon
                        icon={item.iconName}
                        size="lg"
                        style={{ color: item.status ? '#f44336' : 'darkgray' }}
                        //className="circle-icon__icon"
                      />
                    </Avatar>
                  </FlexboxGrid.Item>

                  <FlexboxGrid.Item colspan={20}>
                    <div style={{ margin: '0px 10px 0px 10px' }}>{item.data}</div>
                    {item.status !== '' && <div style={fontStyle}>{item.status}</div>}
                  </FlexboxGrid.Item>
                </FlexboxGrid>
              </List.Item>
            ))}
        </List>
      </Panel>
    </>
  )
}

const settingSchema = {
  header: 'โครงการอยู่ระหว่างการดำเนินการ',
  data: [{ iconName: 'exclamation-circle', status: '', data: 'โครงการ XXXXXXXX' }],
}
